<template>
  <div class="member-popover-container">
    <div class="top">
      <span class="tit">项目成员</span>
      <span
        class="btn"
        :class="selectAll ? 'text-red' : 'text-btn-active'"
        @click="handleShortcuts"
      >
        {{ selectAll ? '清空' : '全选' }}
      </span>
    </div>
    <el-input
      placeholder="搜索项目成员"
      v-model="keywords"
      @input="handleSearch"
      clearable
    >
      <i slot="prefix" class="icon iconfont iconicon_search1"></i>
    </el-input>

    <div class="members-con" v-loading="loading">
      <ul>
        <li v-for="(item, index) in curList" :key="item.uid">
          <el-checkbox
            v-model="item.chos"
            @change="handleChos($event, item)"
          ></el-checkbox>
          <Myavatar
            width="28px"
            height="28px"
            fontSize="12px"
            :imgUrl="item.user_avatar"
            :userName="item.realname"
          >
            {{ item.realname }}
          </Myavatar>
        </li>
      </ul>
      <nothing v-if="!curList.length" width="88px" :config="{ tip: '暂无此成员', type: 'img_search' }"></nothing>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import apiTask from '@/services/api/task/task'

export default {
  props: {
    // 项目id
    projectId: {
      type: [Number, String],
      default: 0
    },
    // 已选人员
    chosMembers: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapState('project/project', {
      projectMember: state => {
        let arr = []
        state.newMember.map(res => {
          arr.push(...res.children)
        })
        return arr
      }
    }),
    curList() {
      return this.keywords ? this.list : this.projectMemberList
    },
    // 已选人员id数组
    chosMembersIds() {
      return this.chosMembers.map(item => item.uid)
    }
  },
  watch: {
    chosMembersIds() {
      let _isSelectAll = true
      this.curList.forEach(item => {
        const _bol = this.chosMembersIds.includes(item.uid)
        if (item.chos !== _bol) {
          // item.chos = _bol
          this.$set(item, 'chos', _bol)
        }

        if (!item.chos) {
          _isSelectAll = false
        }
      })

      this.selectAll = _isSelectAll
    }
  },
  data() {
    return {
      loading: false,
      keywords: '',
      selectAll: false, // 是否全选
      projectMemberList: [],
      list: []
    }
  },
  async mounted() {
    if (!this.projectMember.length) {
      await this.getNewProjectMember({ project_id: this.projectId, working_status: '在职' })  // 获取项目成员
    }
    this.$nextTick(() => {
      // console.log(this.projectMember, 111)
      this.projectMemberList = JSON.parse(JSON.stringify(this.projectMember))
      this.projectMemberList.forEach(item => {
        if (~this.chosMembersIds.indexOf(item.uid)) {
          item.chos = true
        }
      })
    })

  },
  methods: {
    ...mapActions('project/project', ['getNewProjectMember']),
    // 搜索
    handleSearch() {
      this.debounce(() => {
        this.getProjectMembers()
      }, 500)
    },
    async getProjectMembers() {
      this.loading = true
      this.list = []
      const param = {
        project_id: this.projectId,
        working_status: '在职',
        keyword: this.keywords
      }
      const result = await apiTask.getProjectMembers(param)
      if (result) {
        result.forEach(res => {
          for (let key in res) {
            if (res[key].length) {
              this.list.push(...res[key]) //获取成员形成一个数组
            }
          }
        })
      }
      if (!this.keyword) this.selectAll = false
      this.projectMemberList.forEach(item => {
        if (~this.chosMembersIds.indexOf(item.uid)) {
          item.chos = true
        }
      })
      this.loading = false
    },
    // 防抖函数
    debounce(fn, wait) {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(fn, wait)
    },
    handleChos(val, item) {
      let arr = JSON.parse(JSON.stringify(this.chosMembers))
      if (val) {
        // 选择
        arr.push(item)
        // this.$set(item, 'chos', true)
        // item.chos = true
      } else {
        // 取消
        const _index = arr.findIndex(data => data.uid === item.uid)
        if (_index !== -1) {
          arr.splice(_index, 1)
        }
        // this.$set(item, 'chos', false)
        // item.chos = false
      }

      this.$emit('handleMembersChange', arr)
    },
    // 全选 或者清空
    handleShortcuts() {
      if (!this.curList.length) return
      this.selectAll = !this.selectAll
      this.curList.forEach(item => item.chos = this.selectAll)

      const _list = this.selectAll ? this.curList : []
      this.$emit('handleMembersChange', _list)
    }
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/mixin.scss";
.member-popover-container {
  width: 314px;
  box-sizing: border-box;
  padding: 24px 24px 16px;
  border-radius: 4px;
  .top {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .tit {
      font-size: 18px;
      font-weight: 500;
      line-height: 22px;
    }
    .btn {
      cursor: pointer;
      font-size: 14px;
      @include fontColorOpacity(.6);
    }
  }
  /deep/ .el-input__inner {
    height: 40px;
    line-height: 40px;
    margin: 16px 0;
  }
  /deep/ .el-input__prefix {
    line-height: 40px;
    left: 8px;
  }
  .members-con {
    height: 440px;
    overflow-y: scroll;
    position: relative;
    ul {
      li {
        width: 100%;
        height: 40px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        padding-left: 16px;
        box-sizing: border-box;
        &:hover {
          @include bgColorOpacity(.04);
        }
        .el-checkbox {
          margin-right: 14px;
        }
        /deep/ .avatar-box {
          .name-txt {
            margin-left: 16px;
          }
        }

      }
    }
  }
}
</style>
